import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import VerifyEmail from '../views/VerifyEmail.vue'
import { authService } from '@/services/api'


const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresGuest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { requiresGuest: true }
  },
  {
    path: '/catalog/:token',
    name: 'PublicCatalog',
    component: () => import('../views/PublicCatalogView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../views/ForgotPassword.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('../views/ResetPassword.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/verify-email',
    name: 'VerifyEmail',
    component: VerifyEmail,
    meta: { requiresGuest: true }
  },
  {
    path: '/accept-invitation',
    name: 'AcceptInvitation',
    component: () => import('../views/AcceptInvitation.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  // Rutas de documentos
  {
    path: '/documents',
    name: 'documents',
    component: () => import('../views/Documents.vue'),
    meta: { requiresAuth: true, requiresCompanyConfig: true, feature: 'sri_inbox', permission: 'purchases.view' }
  },
  {
    path: '/suppliers',
    name: 'suppliers',
    component: () => import('../views/Suppliers.vue'),
    meta: { requiresAuth: true, requiresCompanyConfig: true, feature: 'contacts_suppliers', permission: 'suppliers.view' }
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import('../views/Reports.vue'),
    meta: { requiresAuth: true, permission: 'reports.view' }
  },
  {
    path: '/reports/detailed-purchases-sales',
    name: 'reports-detailed',
    component: () => import('../views/reports/DetailedPurchasesSalesView.vue'),
    meta: { requiresAuth: true, permission: 'reports.view', feature: 'has_reportes_detallado' }
  },
  {
    path: '/reports/sales-by-seller',
    name: 'reports-sales-by-seller',
    component: () => import('../views/reports/SalesBySellerReportView.vue'),
    meta: { requiresAuth: true, permission: 'reports.view', feature: 'has_reportes_generales' }
  },
  {
    path: '/reports/sri-104',
    name: 'report-104',
    component: () => import('../views/reports/Report104View.vue'),
    meta: { requiresAuth: true, permission: 'reports.view' }
  },
  {
    path: '/reports/ats',
    name: 'report-ats',
    component: () => import('../views/reports/AtsView.vue'),
    meta: { requiresAuth: true, permission: 'reports.view' }
  },
  {
    path: '/reports/portfolio',
    name: 'report-portfolio',
    component: () => import('../views/reports/PortfolioReportView.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'reports.view' }
  },
  {
    path: '/reports/balance-sheet',
    name: 'balance-sheet',
    component: () => import('../views/reports/BalanceSheetView.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'reports.view' }
  },
  {
    path: '/reports/profit-and-loss',
    name: 'profit-and-loss',
    component: () => import('../views/reports/ProfitAndLossView.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'reports.view' }
  },
  {
    path: '/reports/general-ledger',
    name: 'general-ledger',
    component: () => import('../views/reports/GeneralLedgerView.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'reports.view' }
  },
  // Rutas de Inventario
  {
    path: '/inventory',
    name: 'inventory',
    component: () => import('../views/inventory/InventoryManagement.vue'),
    meta: { requiresAuth: true, permission: 'inventory.view' }
  },
  {
    path: '/inventory/movements',
    name: 'inventory-movements',
    component: () => import('../views/inventory/EntradasSalidasView.vue'),
    meta: { requiresAuth: true, permission: 'inventory.view' }
  },
  {
    path: '/inventory/kardex',
    name: 'inventory-kardex',
    component: () => import('../views/inventory/KardexReport.vue'),
    meta: { requiresAuth: true, permission: 'inventory.view' }
  },
  {
    path: '/inventory/warehouses',
    name: 'inventory-warehouses',
    component: () => import('../views/inventory/WarehousesView.vue'),
    meta: { requiresAuth: true, permission: 'inventory.view' }
  },
  {
    path: '/inventory/counts',
    name: 'inventory-counts',
    component: () => import('../views/inventory/InventoryCountView.vue'),
    meta: { requiresAuth: true, permission: 'inventory.view' }
  },
  {
    path: '/inventory/transfers',
    name: 'inventory-transfers',
    component: () => import('../views/inventory/WarehouseTransfersView.vue'),
    meta: { requiresAuth: true, permission: 'inventory.view' }
  },
  {
    path: '/inventory/transfers/create',
    name: 'inventory-transfers-create',
    component: () => import('../views/inventory/WarehouseTransferCreateView.vue'),
    meta: { requiresAuth: true, permission: 'inventory.view' }
  },
  {
    path: '/inventory/transfers/:id',
    name: 'inventory-transfers-detail',
    component: () => import('../views/inventory/WarehouseTransferDetailView.vue'),
    meta: { requiresAuth: true, permission: 'inventory.view' }
  },
  {
    path: '/inventory/deliveries',
    alias: '/inventory/delivery-orders',
    name: 'inventory-deliveries',
    component: () => import('../views/inventory/DeliveryOrdersView.vue'),
    meta: { requiresAuth: true, permission: 'inventory.view' }
  },
  {
    path: '/inventory/units',
    name: 'inventory-units',
    component: () => import('../views/inventory/UnitsView.vue'),
    meta: { requiresAuth: true, permission: 'inventory.view' }
  },
  // Rutas de gesti├│n
  {
    path: '/companies',
    name: 'companies',
    component: () => import('../views/Companies.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import('../views/Categories.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/accounts',
    name: 'accounts',
    component: () => import('../views/Accounts.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'accounting.view' }
  },
  {
    path: '/centros-costo',
    name: 'centros-costo',
    component: () => import('../views/CentrosCosto.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'accounting.view' }
  },
  {
    path: '/analysis',
    name: 'analysis',
    component: () => import('../views/DocumentAnalysis.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'accounting.view' }
  },
  {
    path: '/journal-entries',
    name: 'journal-entries',
    component: () => import('../views/JournalEntries.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'accounting.journal_entries' }
  },
  {
    path: '/accounting-periods',
    name: 'accounting-periods',
    component: () => import('@/views/AccountingPeriods.vue'),
    meta: { requiresAuth: true, plan: 'enterprise', feature: 'contabilidad', permission: 'accounting.view' }
  },
  {
    path: '/accounting/periods',
    name: 'accounting-periods-alias',
    component: () => import('@/views/AccountingPeriods.vue'),
    meta: { requiresAuth: true, plan: 'enterprise', feature: 'contabilidad', permission: 'accounting.view' }
  },
  {
    path: '/budgets',
    name: 'Budgets',
    component: () => import('@/views/AccountingBudgets.vue'),
    meta: { requiresAuth: true, plan: 'enterprise', permission: 'accounting.view' }
  },
  {
    path: '/budgets/:id/edit',
    name: 'BudgetEditor',
    component: () => import('@/views/reports/AccountingBudgetEditor.vue'),
    meta: { requiresAuth: true, plan: 'enterprise', permission: 'accounting.view' }
  },
  {
    path: '/bank-accounts',
    name: 'bank-accounts',
    component: () => import('../views/BankAccounts.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/treasury/bank-movements',
    name: 'BankMovementsList',
    component: () => import('../views/BankMovementsList.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/treasury/bank-movements/create',
    name: 'BankMovementCreate',
    component: () => import('../views/BankMovementUpsert.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/treasury/bank-movements/edit/:id',
    name: 'BankMovementEdit',
    component: () => import('../views/BankMovementUpsert.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/bank-reconciliations',
    name: 'bank-reconciliation-list',
    component: () => import('../views/BankReconciliationList.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/bank-reconciliations/process',
    name: 'bank-reconciliation-process',
    component: () => import('../views/BankReconciliationProcess.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/bank-reconciliations/:id',
    name: 'bank-reconciliation-detail',
    component: () => import('../views/BankReconciliationDetail.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/companies/:companyId/treasury/bank-transactions',
    name: 'bank-transactions-list',
    component: () => import('../views/BankTransactionList.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/companies/:companyId/treasury/bank-transactions/create',
    name: 'bank-transactions-create',
    component: () => import('../views/BankTransactionUpsert.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/companies/:companyId/treasury/bank-transactions/edit/:id',
    name: 'bank-transactions-edit',
    component: () => import('../views/BankTransactionUpsert.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/companies/:companyId/treasury/mass-transactions',
    name: 'mass-transactions-list',
    component: () => import('../views/MassTransactionList.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/companies/:companyId/treasury/mass-transactions/create',
    name: 'mass-transactions-create',
    component: () => import('../views/MassTransactionUpsert.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/companies/:companyId/treasury/mass-transactions/edit/:id',
    name: 'mass-transactions-edit',
    component: () => import('../views/MassTransactionUpsert.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/treasury/document-crossing',
    name: 'document-crossing',
    component: () => import('../views/treasury/DocumentCrossingView.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/companies/:companyId/treasury/petty-cash-replenishments',
    name: 'petty-cash-replenishments-list',
    component: () => import('../views/treasury/PettyCashReplenishmentList.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/companies/:companyId/treasury/petty-cash-replenishments/create',
    name: 'petty-cash-replenishments-create',
    component: () => import('../views/treasury/PettyCashReplenishmentView.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/companies/:companyId/treasury/petty-cash-replenishments/edit/:id',
    name: 'petty-cash-replenishments-edit',
    component: () => import('../views/treasury/PettyCashReplenishmentView.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/companies/:companyId/treasury/deposits',
    name: 'deposits-list',
    component: () => import('../views/treasury/DepositListView.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/companies/:companyId/treasury/deposits/create',
    name: 'deposits-create',
    component: () => import('../views/treasury/DepositCreateView.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/treasury/payments',
    name: 'treasury-payments',
    component: () => import('../views/treasury/PaymentsManagement.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'contabilidad', permission: 'treasury.view' }
  },
  {
    path: '/analysis-progress',
    name: 'analysis-progress',
    component: () => import('../views/AnalysisProgress.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/sri-download',
    name: 'sri-download',
    component: () => import('../views/SriDownload.vue'),
    meta: { requiresAuth: true, permission: 'purchases.download' }
  },
  {
    path: '/download-progress',
    name: 'download-progress',
    component: () => import('../views/DownloadProgress.vue'),
    meta: { requiresAuth: true }
  },
  // Rutas de usuario
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/Profile.vue'),
    meta: { requiresAuth: true }
  },
  // Rutas de sistema
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/Settings.vue'),
    meta: { requiresAuth: true, permission: 'settings.view' }
  },
  {
    path: '/upgrade',
    name: 'upgrade',
    component: () => import('../views/UpgradePlan.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/reports/statement/:type/:entityId',
    name: 'personal-statement',
    component: () => import('../views/reports/PersonalStatementView.vue'),
    meta: { requiresAuth: true }
  },
  // Rutas de administraci├│n del sistema (Solo System Admin)
  {
    path: '/admin/users',
    name: 'admin-users',
    component: () => import('../views/AdminUsers.vue'),
    meta: { requiresAuth: true, requiresSystemAdmin: true }
  },
  {
    path: '/admin/reports',
    name: 'admin-reports',
    component: () => import('../views/AdminReports.vue'),
    meta: { requiresAuth: true, requiresSystemAdmin: true }
  },
  {
    path: '/admin/subscription-plans',
    name: 'admin-subscription-plans',
    component: () => import('../views/AdminPlans.vue'),
    meta: { requiresAuth: true, requiresSystemAdmin: true }
  },
  {
    path: '/admin/settings',
    name: 'admin-settings',
    component: () => import('../views/AdminSettings.vue'),
    meta: { requiresAuth: true, requiresSystemAdmin: true }
  },
  {
    path: '/admin/account-classes',
    name: 'admin-account-classes',
    component: () => import('../views/AdminAccountClasses.vue'),
    meta: { requiresAuth: true, requiresSystemAdmin: true }
  },
  {
    path: '/admin/retention-catalogs',
    name: 'admin-retentions',
    component: () => import('../views/AdminRetentions.vue'),
    meta: { requiresAuth: true, requiresSystemAdmin: true }
  },
  {
    path: '/admin/marketing',
    name: 'admin-marketing',
    component: () => import('../views/AdminMarketing.vue'),
    meta: { requiresAuth: true, requiresSystemAdmin: true }
  },
  // Módulo de Soporte
  {
    path: '/support',
    name: 'support',
    component: () => import('../views/support/SupportTickets.vue'),
    meta: { requiresAuth: true, permission: 'support.view' }
  },
  {
    path: '/admin/support',
    name: 'admin-support',
    component: () => import('../views/support/SupportAdminInbox.vue'),
    meta: { requiresAuth: true, requiresSupportAgent: true }
  },
  // Rutas de facturaci├│n electr├│nica
  {
    path: '/companies/:companyId/billing/products',
    name: 'products',
    component: () => import('../views/Products.vue'),
    meta: { requiresAuth: true, permission: 'products.view' }
  },
  {
    path: '/companies/:companyId/billing/products/create',
    name: 'products-create',
    component: () => import('../views/billing/ProductUpsert.vue'),
    meta: { requiresAuth: true, permission: 'products.create' }
  },
  {
    path: '/companies/:companyId/billing/products/:productId/edit',
    name: 'products-edit',
    component: () => import('../views/billing/ProductUpsert.vue'),
    meta: { requiresAuth: true, permission: 'products.edit' }
  },
  {
    path: '/companies/:companyId/billing/clients',
    name: 'clients',
    component: () => import('../views/Clients.vue'),
    meta: { requiresAuth: true, feature: 'contacts_clients', permission: 'clients.view' }
  },
  {
    path: '/companies/:companyId/billing/documents',
    name: 'electronic-documents',
    component: () => import('../views/ElectronicDocuments.vue'),
    meta: { requiresAuth: true, requiresCompanyConfig: true, permission: 'invoices.view' }
  },
  // Compras y Gastos Avanzados
  {
    path: '/companies/:companyId/purchases',
    name: 'purchases-list',
    component: () => import('../views/purchases/PurchasesList.vue'),
    meta: { requiresAuth: true, feature: 'purchase_entry', permission: 'purchases.view' }
  },
  {
    path: '/companies/:companyId/purchases/create',
    name: 'purchases-create',
    component: () => import('../views/purchases/PurchaseUpsert.vue'),
    meta: { requiresAuth: true, feature: 'purchase_entry', permission: 'purchases.create' }
  },
  {
    path: '/companies/:companyId/purchases/:purchaseId/edit',
    name: 'purchases-edit',
    component: () => import('../views/purchases/PurchaseUpsert.vue'),
    meta: { requiresAuth: true, feature: 'purchase_entry', permission: 'purchases.edit' }
  },
  // Cotizaciones / Proformas
  {
    path: '/companies/:companyId/billing/quotes',
    name: 'quotes',
    component: () => import('../views/Quotes.vue'),
    meta: { requiresAuth: true, permission: 'quotes.view' }
  },
  // Usuarios y Permisos - Solo Enterprise
  {
    path: '/companies/:companyId/users-permissions',
    name: 'users-permissions',
    component: () => import('../views/UsersPermissions.vue'),
    meta: { requiresAuth: true, requiresPlan: 'enterprise', feature: 'usuarios', permission: 'users.view' }
  },
  // Generación de documentos (Billing Views)
  {
    path: '/companies/:companyId/billing/generate/invoice',
    name: 'generate-invoice',
    component: () => import('../views/billing/CreateInvoice.vue'),
    meta: { requiresAuth: true, requiresCompanyConfig: true, permission: 'invoices.create' }
  },
  {
    path: '/companies/:companyId/billing/batches',
    name: 'billing-batches-list',
    component: () => import('../views/billing/BatchList.vue'),
    meta: { requiresAuth: true, requiresCompanyConfig: true, permission: 'document_batches.view' }
  },
  {
    path: '/companies/:companyId/billing/batches/:batchId',
    name: 'billing-batches-detail',
    component: () => import('../views/billing/BatchDetail.vue'),
    meta: { requiresAuth: true, requiresCompanyConfig: true, permission: 'document_batches.view' }
  },
  {
    path: '/companies/:companyId/billing/batches/:batchId/add',
    name: 'billing-batches-invoice-create',
    component: () => import('../views/billing/BatchInvoiceCreate.vue'),
    meta: { requiresAuth: true, requiresCompanyConfig: true, permission: 'document_batches.create' }
  },
  {
    path: '/companies/:companyId/billing/batches/:batchId/edit/:documentId',
    name: 'billing-batches-invoice-edit',
    component: () => import('../views/billing/BatchInvoiceEdit.vue'),
    meta: { requiresAuth: true, requiresCompanyConfig: true, permission: 'document_batches.edit' }
  },
  {
    path: '/companies/:companyId/billing/generate/credit-note',
    name: 'generate-credit-note',
    component: () => import('../views/billing/CreateCreditNote.vue'),
    meta: { requiresAuth: true, requiresCompanyConfig: true, permission: 'invoices.create' }
  },
  {
    path: '/companies/:companyId/billing/generate/debit-note',
    name: 'generate-debit-note',
    component: () => import('../views/billing/CreateDebitNote.vue'),
    meta: { requiresAuth: true, requiresCompanyConfig: true, permission: 'invoices.create' }
  },
  {
    path: '/companies/:companyId/billing/generate/remission-guide',
    name: 'generate-remission-guide',
    component: () => import('../views/billing/CreateRemissionGuide.vue'),
    meta: { requiresAuth: true, requiresCompanyConfig: true, permission: 'invoices.create' }
  },
  {
    path: '/companies/:companyId/billing/generate/liquidation',
    name: 'generate-liquidation',
    component: () => import('../views/billing/CreateLiquidation.vue'),
    meta: { requiresAuth: true, requiresCompanyConfig: true, permission: 'invoices.create' }
  },
  {
    path: '/companies/:companyId/billing/generate/retention',
    name: 'generate-retention',
    component: () => import('../views/billing/CreateRetention.vue'),
    meta: { requiresAuth: true, requiresCompanyConfig: true, permission: 'purchases.retention' }
  },
  {
    path: '/companies/:companyId/billing/settings',
    name: 'billing-settings',
    component: () => import('../views/BillingSettings.vue'),
    meta: { requiresAuth: true, permission: 'settings.billing' }
  },
  {
    path: '/companies/:companyId/pos/config',
    name: 'pos-config',
    component: () => import('../views/pos/PosConfigView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/companies/:companyId/pos/config/:posId',
    name: 'pos-config-edit',
    component: () => import('../views/pos/PosConfigEditView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/companies/:companyId/pos/sessions',
    name: 'pos-sessions',
    component: () => import('../views/pos/PosSessionsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/companies/:companyId/rrhh/settings',
    name: 'rrhh-settings',
    component: () => import('../views/rrhh/RrhhSettings.vue'),
    meta: { requiresAuth: true, feature: 'has_rrhh', permission: 'rrhh.departments' }
  },
  {
    path: '/companies/:companyId/rrhh/roles',
    name: 'rrhh-roles',
    component: () => import('../views/rrhh/Roles.vue'),
    meta: { requiresAuth: true, feature: 'has_rrhh', permission: 'rrhh.payrolls' }
  },
  {
    path: '/companies/:companyId/rrhh/consulta-roles',
    name: 'rrhh-consulta-roles',
    component: () => import('../views/rrhh/ConsultaRoles.vue'),
    meta: { requiresAuth: true, feature: 'has_rrhh', permission: 'rrhh.payrolls' }
  },
  {
    path: '/companies/:companyId/rrhh/prestamos',
    name: 'rrhh-prestamos',
    component: () => import('../views/rrhh/Prestamos.vue'),
    meta: { requiresAuth: true, feature: 'has_rrhh', permission: 'rrhh.loans' }
  },
  {
    path: '/companies/:companyId/rrhh/decimos',
    name: 'rrhh-decimos',
    component: () => import('../views/rrhh/Decimos.vue'),
    meta: { requiresAuth: true, feature: 'has_rrhh', permission: 'rrhh.payrolls' }
  },
  {
    path: '/companies/:companyId/rrhh/pagos',
    name: 'rrhh-pagos',
    component: () => import('../views/rrhh/Pagos.vue'),
    meta: { requiresAuth: true, feature: 'has_rrhh', permission: 'rrhh.payrolls' }
  },
  {
    path: '/companies/:companyId/employees',
    name: 'employees',
    component: () => import('../views/rrhh/Employees.vue'),
    meta: { requiresAuth: true, feature: 'has_rrhh_empleados', permission: 'rrhh.employees' }
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    component: () => import('../views/Forbidden.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// Navigation guards
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = authService.isAuthenticated()
  const currentUser = authService.getCurrentUser()

  // Si la ruta requiere autenticaci├│n y el usuario no est├í autenticado
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ 
      path: '/login', 
      query: { redirect: to.fullPath } 
    })
    return
  }

  // Si la ruta es para invitados (login/register) y el usuario ya est├í autenticado
  if (to.meta.requiresGuest && isAuthenticated) {
    next('/dashboard')
    return
  }

  // Verificar si la ruta requiere ser administrador del sistema
  if (to.meta.requiresSystemAdmin && isAuthenticated) {
    if (!currentUser?.is_system_admin) {
      // Redirigir al dashboard si no es admin del sistema
      next('/dashboard')
      return
    }
  }

  // Módulo de Soporte: bandeja solo para administradores del sistema y agentes de soporte
  if (to.meta.requiresSupportAgent && isAuthenticated) {
    if (!currentUser?.is_system_admin && !currentUser?.is_support_agent) {
      next('/dashboard')
      return
    }
  }

  // Verificar si la ruta requiere un plan específico o característica
  if ((to.meta.requiresPlan === 'enterprise' || to.meta.feature) && isAuthenticated) {
    // Importar el store de suscripci├│n din├ímicamente para evitar imports circulares
    const { useSubscriptionStore } = await import('@/stores/subscription')
    const subscriptionStore = useSubscriptionStore()

    // Cargar informaci├│n del plan si no est├í cargada
    const companyId = localStorage.getItem('current_company_id')
    if (companyId && !subscriptionStore.planInfo) {
      await subscriptionStore.loadPlanInfo(companyId)
    }

    // Verificar si tiene acceso a la caracter├¡stica
    const feature = to.meta.feature
    if (feature && !subscriptionStore.hasFeature(feature)) {
      next({
        path: '/upgrade',
        query: { feature: feature, from: to.fullPath }
      })
      return
    }
  }

  // ­ƒöÆ RESTRICTION: Route Permissions
  if (to.meta.permission && isAuthenticated) {
    const { usePermissionsStore } = await import('@/stores/permissions')
    const permissionsStore = usePermissionsStore()
    
    const companyId = localStorage.getItem('current_company_id')
    if (companyId) {
      await permissionsStore.fetchUserPermissions(companyId)
      
      const permission = to.meta.permission
      if (!permissionsStore.hasPermission(permission, currentUser?.is_system_admin)) {
        console.warn(`Access denied for permission: ${permission}`)
        next({
          path: '/forbidden',
          query: { 
            permission: permission, 
            from_name: to.name || to.path,
            redirect: to.fullPath 
          }
        })
        return
      }
    }
  }

  // ­ƒöÆ RESTRICTION: User without plan cannot access operational routes
  // Operational routes usually are: dashboard, documents, etc.
  // Allowed routes: companies, settings, profile, upgrade, billing-settings
  if (isAuthenticated && !currentUser?.subscription_plan_id && !currentUser?.is_system_admin) {
    // List of allowed paths or prefixes
    const allowedPaths = ['/companies', '/settings', '/profile', '/upgrade', '/logout', '/verify-email', '/support', '/admin/support'];

    // Check if current path starts with any allowed path
    const isAllowed = allowedPaths.some(path => to.path.startsWith(path));

    // Also allow root path (Landing)
    if (to.path === '/') {
      next();
      return;
    }

    if (!isAllowed) {
      // Redirect to Companies (SAFE LANDING)
      next('/companies');
      return;
    }
  }

  // 🛡️ RESTRICTION: Company Not Configured (No Invoicing Access)
  if (to.meta.requiresCompanyConfig && isAuthenticated) {
    const { useCompany } = await import('@/composables/useCompany')
    const { currentCompany, loadCompanies, initialized } = useCompany()
    
    // 1. Ensure companies are loaded
    if (!initialized.value) {
        try {
            await loadCompanies()
        } catch (e) {
            console.error('Failed to load companies in guard', e)
        }
    }
    
    // 2. Check configuration status
    // If currentCompany is null (no companies), block
    if (!currentCompany.value) {
        console.warn('Access denied: No company selected or created')
        next('/dashboard')
        return
    }
  }

  next()
})

// Manejo automático de errores de importación de módulos dinámicos en Vite (TypeError: Importing a module script failed)
router.onError((error) => {
  const isChunkLoadFailed = error?.message?.includes('Importing a module script failed') || 
                            error?.message?.includes('Failed to fetch dynamically imported module');
  if (isChunkLoadFailed) {
    const isReloaded = sessionStorage.getItem('vite_chunk_reload');
    if (!isReloaded) {
      sessionStorage.setItem('vite_chunk_reload', 'true');
      window.location.reload();
    }
  }
})

export default router
